
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import tButton from '@/components/Button/tButton.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import BScroll from 'better-scroll';
import tableMixin from './tableMixin';
import bModal from './components/bModal.vue';

@Component({
  components: {
    tButton,
    bModal,
  },
})
export default class AssetWrapper extends Mixins(BsMixin, tableMixin) {
  private arrs: Array<any> = [];

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/chapter/video:add',
    icon: 'plus',
    callback: this.handleAddResource,
    log: {
      name: '视频 - 新增',
      component: 'trial/manage/bModal',
    },
  }];

  private actionUpload: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/chapter/video:add',
    icon: 'plus',
    callback: this.handleRelate,
    log: {
      name: '视频 - 新增',
      component: 'trial/manage/bModal',
    },
  }];

  private visible: any = {
    upload: false,
    contract: false,
    rescource: false,
    cropper: false,
  };

  private row: any = {};

  private bs?: BScroll;

  private title: string = '添加视频';

  public $refs!: {
    chapterVideo: Element,
  }

  mounted() {
    this.initBS(this.$refs.chapterVideo, {
      click: false,
    });
  }

  handleAddResource() {
    this.row.stepPid = this.chapterId;
    this.title = '添加视频';
    this.visible.rescource = true;
  }

  handleEdit(row: any) {
    this.visible.rescource = true;
    this.title = '修改视频';
    this.row = row;
  }

  refrsh() {
    this.getData(this.chapterId);
  }

  handleCellClick(row:any, column: any, event: any) {
    if (column.label === '缩略图标') {
      this.visible.cropper = true;
      this.row = row;
    }
  }

  handleRelate() {
    this.title = '添加视频';
    this.visible.rescource = true;
    this.videoForm.pid = '';
    this.videoForm.videoTitle = '';
    this.videoForm.videoId = '';
  }

  handleEditVideo(row: any) {
    this.videoForm.pid = row.pid;
    this.videoForm.videoTitle = row.stepVideoTitle;
    this.videoForm.videoId = row.videoId;
    this.videoForm.sort = row.seq
    this.videoForm.userType = row.userType
    this.title = '修改视频';
    this.visible.rescource = true;
  }
}
